export default __webpack_public_path__ + "static/media/home-cat.22af82c5.png";